import { motion } from "framer-motion";

export const Urgency = () => (
  <section className="relative px-5 py-20 sm:px-8 sm:py-28" data-testid="urgency-section">
    <div className="mx-auto max-w-2xl text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="rounded-3xl border border-[#0f93cc]/25 bg-gradient-to-b from-[#0f93cc]/10 to-transparent p-8 sm:p-10"
      >
        <h2 className="font-display text-xl font-bold text-white sm:text-2xl">
          Everyone will know eventually.
          <br />
          <span className="text-[#0f93cc]">But not everyone will know first.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-lg text-sm leading-relaxed text-white/60 sm:text-base">
          Some offers across the MIK ecosystem — around Teacher&rsquo;s Day — will be
          available only to a limited number of participants. Join now so you&rsquo;re
          not the one who finds out too late.
        </p>
      </motion.div>
    </div>
  </section>
);
